import { NgModule } from "@angular/core";
import { Routes, RouterModule } from "@angular/router";

import { LoginComponent } from "./login/login.component";
import { HomeComponent } from "./home/home.component";
import { ApplicationListComponent } from "./application/applicationlist/applicationlist.component";
import { ApplicationViewComponent } from "./application/applicationview/applicationview.component";
import { ApplicationNewComponent } from "./application/applicationnew/applicationnew.component";
import { MetaobjectListComponent } from "./metaobject/metaobjectlist/metaobjectlist.component";
import { MetaobjectViewComponent } from "./metaobject/metaobjectview/metaobjectview.component";
import { MetaobjectNewComponent } from "./metaobject/metaobjectnew/metaobjectnew.component";
import { MetafieldViewComponent } from "./metafield/metafieldview/metafieldview.component";
import { MetafieldNewComponent } from "./metafield/metafieldnew/metafieldnew.component";
import { MetabuttonViewComponent } from "./metabutton/metabuttonview/metabuttonview.component";
import { MetabuttonNewComponent } from "./metabutton/metabuttonnew/metabuttonnew.component";
import { MetarelatedlistdropComponent } from "./page/metarelatedlistdrop/metarelatedlistdrop.component";

import { RecordTypeViewComponent } from "./metaobject/recordtypeview/recordtypeview.component";
import { RecordTypeNewComponent } from "./metaobject/recordtypenew/recordtypenew.component";

import { MetaLayoutNewComponent } from "./metalayout/metalayoutnew/metalayoutnew.component";

import { CustomViewNewComponent } from "./customview/customviewnew/customviewnew.component";
// import { PageComponent } from './page/page.component';
import { FieldComponent } from "./page/field/field.component";
import { FieldLayoutComponent } from "./page/field-layout/field-layout.component";
import { PageComponent } from "./page/page.component";
import { CustomViewListComponent } from "./customview/customviewlist/customviewlist.component";
import { MetaLayoutViewComponent } from "./metalayout/metalayoutview/metalayoutview.component";
import { MetaLayoutListComponent } from "./metalayout/metalayoutlist/metalayoutlist.component";
import { MetaLayoutQuickComponent } from "./metalayout/metalayoutquick/metalayoutquick.component";
import { MetaLayoutSelectorComponent } from "./metalayout/metalayoutselector/metalayoutselector.component";
import { GlobalactionComponent } from "./globalaction/globalaction.component";
import { NewactionComponent } from "./globalaction/newaction/newaction.component";
import { GlobalactionLayoutComponent } from "./globalaction/globalaction-layout/globalaction-layout.component";
import { SearchlayoutComponent } from "./searchlayout/searchlayout/searchlayout.component";
import { SearchprofilelayoutComponent } from "./searchlayout/searchprofilelayout/searchprofilelayout.component";
import { SearchlayoutfieldsComponent } from "./searchlayout/searchlayoutfields/searchlayoutfields.component";
import { EmptySectionComponent } from "./page/empty-section/empty-section.component";
import { ProcessesComponent } from "./processes/processes.component";
import { NewprocessComponent } from "./processes/newprocess/newprocess.component";
import { ProcessfieldComponent } from "./processes/processfield/processfield.component";
import { RecordtypelayoutComponent } from "./metaobject/recordtypelayout/recordtypelayout.component";
import { RecordtypeComponent } from "./recordtype/recordtype.component";
import { LayoutassignmentComponent } from "./metaobject/layoutassignment/layoutassignment.component";
import { MetafieldhistoryComponent } from "./metafield/metafieldhistory/metafieldhistory.component";
import { ReporttypesComponent } from "./reporttypes/reporttypes.component";
import { NewreporttypeComponent } from "./reporttypes/newreporttype/newreporttype.component";
import { ReportsComponent } from "./reports/reports.component";
import { FolderComponent } from "./folder/folder.component";
import { SubfolderComponent } from "./folder/subfolder/subfolder.component";
import { RefinedlayoutnewComponent } from "./refinedlayout/refinedlayoutnew/refinedlayoutnew.component";
import { ReporttypelayoutComponent } from "./reporttypes/reporttypelayout/reporttypelayout.component";
import { AllReportsComponent } from "./reports/all-reports/all-reports.component";
import { NewreportComponent } from "./reports/newreport/newreport.component";
import { NewconvertsettingComponent } from "./convertsetting/newconvertsetting/newconvertsetting.component";
import { ConvertsettinglistComponent } from "./convertsetting/convertsettinglist/convertsettinglist.component";
import { ConvertmappingfieldComponent } from "./convertsetting/convertmappingfield/convertmappingfield.component";
import { DashboardComponent } from "./dashboard/dashboard/dashboard.component";
import { TestDashboardComponent } from "./dashboard/test-dashboard/test-dashboard.component";
import { DashboardlistComponent } from "./dashboard/dashboardlist/dashboardlist.component";
import { WizardlayoutlistComponent } from "./wizardlayout/wizardlayoutlist/wizardlayoutlist.component";
import { WizardlayoutnewComponent } from "./wizardlayout/wizardlayoutnew/wizardlayoutnew.component";
import { ValidationrulenewComponent } from "./validationrule/validationrulenew/validationrulenew.component";
import { MatchingrulelistComponent } from "./matchingrule/matchingrulelist/matchingrulelist.component";
import { MatchingrulenewComponent } from "./matchingrule/matchingrulenew/matchingrulenew.component";
import { DuplicaterulelistComponent } from "./duplicaterule/duplicaterulelist/duplicaterulelist.component";
import { DuplicaterulenewComponent } from "./duplicaterule/duplicaterulenew/duplicaterulenew.component";
import { CrudmessagenewComponent } from "./crudmessage/crudmessagenew/crudmessagenew.component";
import { CrudmessagelistComponent } from "./crudmessage/crudmessagelist/crudmessagelist.component";
import { ErrormessagelistComponent } from "./errormessage/errormessagelist/errormessagelist.component";
import { ErrormessagenewComponent } from "./errormessage/errormessagenew/errormessagenew.component";
import { SectionrootlistComponent } from "./modulesettings/sectionrootlist/sectionrootlist.component";
import { SectionrootnewComponent } from "./modulesettings/sectionrootnew/sectionrootnew.component";
import { ModulesettinglistComponent } from "./modulesettings/modulesettinglist/modulesettinglist.component";
import { ModulesettingnewComponent } from "./modulesettings/modulesettingnew/modulesettingnew.component";
import { MetafielddependencieslistComponent } from "./metafield/metafielddependencies/metafielddependencieslist/metafielddependencieslist.component";
import { MetafielddependenciesnewComponent } from "./metafield/metafielddependencies/metafielddependenciesnew/metafielddependenciesnew.component";
import { RecordtypepicklistComponent } from "./metaobject/recordtypepicklist/recordtypepicklist.component";
import { DomainSettingslistComponent } from "./domainsettings/domainsettingslist/domain-settings.component";
import { DomainConfinewComponent } from "./domainsettings/domainsettingsnew/domain-confinew.component";
import { DomainConfigSectionComponent } from "./domainsettings/domainsettingssection/domain-config-section.component";
import { DomainsettingsconfigkeyComponent } from "./domainsettings/domainsettingsfields/domainsettingsconfigkey.component";
import { domainsectionectionnewComponent } from "./domainsettings/domainsettingsectionlist/domainsettingsectionnew.component";
import { DomainfieldslistComponent } from "./domainsettings/domainfieldslist/domainfieldslist.component";
import { ErrorcodelistComponent } from "./errorcode/errorcodelist/errorcodelist.component";
import { ErrorcodenewComponent } from "./errorcode/errorcodenew/errorcodenew.component";

const routes: Routes = [
  { path: "", component: LoginComponent },
  { path: "login", component: LoginComponent },
  //{ path: 'home', component: HomeComponent }
  {
    component: HomeComponent,
    path: "home",
    children: [
      { path: "applist", component: ApplicationListComponent },

      {
        path: "applicationdetail/:id/:appname",
        component: ApplicationViewComponent
      },
      { path: "application/:mode", component: ApplicationNewComponent },
      {
        path: "application/:mode/:id/:appname",
        component: ApplicationNewComponent
      },

      { path: "globalaction", component: GlobalactionComponent },

      { path: "metaobjectlist", component: MetaobjectListComponent },

      { path: "globalaction/newaction/:mode", component: NewactionComponent },

      {
        path: "globalaction/newaction/:mode/:name/:id",
        component: NewactionComponent
      },

      {
        path: "globalaction/layout/:mode/:id/:object/:objectid/:name/:metalayoutid/:actiontype",
        component: GlobalactionLayoutComponent
      },

      { path: "searchlayout", component: SearchlayoutComponent },

      { path: "report/:mode", component: NewreportComponent },
      {
        path: "report/:mode/:name/:id",
        component: NewreportComponent
      },
      { path: "reporttypes", component: ReporttypesComponent },

      { path: "reporttype/:mode", component: NewreporttypeComponent },

      {
        path: "reporttype/:mode/:label/:id",
        component: NewreporttypeComponent
      },

      {
        path: "reporttypelayout/layout/:mode/:id",
        component: ReporttypelayoutComponent
      },

      { path: "reports", component: ReportsComponent },

      { path: "dashboardlist", component: DashboardlistComponent },

      { path: "dashboard/:mode", component: TestDashboardComponent },

      {
        path: "dashboard/:mode/:name/:id",
        component: TestDashboardComponent
      },

      { path: "wizardlayoutlist", component: WizardlayoutlistComponent },

      { path: "wizardlayout/:mode", component: WizardlayoutnewComponent },

      { path: "matchingrulelist", component: MatchingrulelistComponent },

      {
        path: "matchingrule/:template/:mode",
        component: MatchingrulenewComponent
      },

      {
        path: "matchingrule/:template/:mode/:objectname/:objectid",
        component: MatchingrulenewComponent
      },
      {
        path: "matchingrule/:template/:mode/:name/:id/:objectname/:objectid",
        component: MatchingrulenewComponent
      },

      { path: "duplicaterulelist", component: DuplicaterulelistComponent },

      {
        path: "duplicaterule/:template/:mode",
        component: DuplicaterulenewComponent
      },

      {
        path: "duplicaterule/:template/:mode/:objectname/:objectid",
        component: DuplicaterulenewComponent
      },

      {
        path: "duplicaterule/:template/:mode/:name/:id/:objectname/:objectid",
        component: DuplicaterulenewComponent
      },

      { path: "convertsetting/:mode", component: NewconvertsettingComponent },

      { path: "convertsettinglist", component: ConvertsettinglistComponent },

      {
        path: "convertsetting/fieldmapping/:mode/:id/:name/:objectname/:objectid",
        component: ConvertmappingfieldComponent
      },

      {
        path: "convertsetting/:mode/:id/:name/:objectname/:objectid",
        component: NewconvertsettingComponent
      },

      { path: "folder/new", component: FolderComponent },

      { path: "folder", component: SubfolderComponent },

      {
        path: "folder/:foldermode/:parentid/:parentfoldername",
        component: SubfolderComponent
      },

      // { path: "folder/edit/:id/:name", component: ReportsComponent },

      { path: "processes", component: ProcessesComponent },

      { path: "process/:mode", component: NewprocessComponent },

      {
        path: "processes/processfield/:mode/:id/:metaobjectname/:metaobjectid/:name/:description/:active",
        component: ProcessfieldComponent
      },

      { path: "process/:mode/:name/:id", component: NewprocessComponent },

      {
        path: "searchlayout/:label/:objectid",
        component: SearchprofilelayoutComponent
      },

      {
        path: "searchlayout/:mode/:id/:objectName/:objectId/:profile/:profileid",
        component: SearchlayoutfieldsComponent
      },

      {
        path: "searchlayout/:mode/:objectName/:objectId/:profile/:profileid",
        component: SearchlayoutfieldsComponent
      },

      {
        path: "metaobjectdetail/:id/:objectname",
        component: MetaobjectViewComponent
      },
      { path: "metaobject/:mode", component: MetaobjectNewComponent },
      {
        path: "metaobject/:mode/:id/:objectname",
        component: MetaobjectNewComponent
      },

      {
        path: "metafielddetail/:id/:fieldname/:metaobjectid/:metaobjectname/:parentobjectid/:parentobjectname/:embeddedobject/:virtualobject",
        component: MetafieldViewComponent
      },
      {
        path: "metafield/:mode/:metaobjectid/:metaobjectname/:parentobjectid/:parentobjectname/:embeddedobject/:virtualobject",
        component: MetafieldNewComponent
      },
      {
        path: "metafield/:mode/:id/:fieldname/:metaobjectid/:metaobjectname/:parentobjectid/:parentobjectname/:embeddedobject/:virtualobject",
        component: MetafieldNewComponent
      },

      {
        path: "metafieldhistory/:mode/:metaobjectid/:metaobjectname",
        component: MetafieldhistoryComponent
      },

      {
        path: "fielddependencies/list/:metaobjectid/:metaobjectname",
        component: MetafielddependencieslistComponent
      },
      {
        path: "fielddependencies/:mode/:id/:metaobjectid/:metaobjectname",
        component: MetafielddependenciesnewComponent
      },
      {
        path: "fielddependencies/:mode/:metaobjectid/:metaobjectname",
        component: MetafielddependenciesnewComponent
      },
      {
        path: "recordtypedetail/:id/:name/:metaobjectid/:metaobjectname",
        component: RecordTypeViewComponent
      },
      {
        path: "recordtype/:mode/:metaobjectid/:metaobjectname",
        component: RecordTypeNewComponent
      },
      {
        path: "recordtype/layoutassignment/:mode/:metaobjectname/:metaobjectid/profile",
        component: LayoutassignmentComponent
      },
      // {
      //   path: "recordtype/:mode/:metaobjectid/:metaobjectname",
      //   component: RecordtypeComponent,
      // },

      {
        path: "recordtype/:mode/:metaobjectid/:name/:labelname/layout",
        component: RecordtypelayoutComponent
      },

      {
        path: "record/:mode/:metaobjectid/:name/:labelname/:recordtypeid",
        component: RecordtypelayoutComponent
      },

      {
        path: "recordtype/:mode/:id/:name/:metaobjectid/:metaobjectname",
        component: RecordTypeNewComponent
      },

      {
        path: "recordtype/picklist/available/:fieldname/:id/:name/:metaobjectid/:metaobjectname",
        component: RecordtypepicklistComponent
      },

      {
        path: "metabuttondetail/:id/:name/:metaobjectid/:metaobjectname/:parentobjectid/:parentobjectname/:embeddedobject",
        component: MetabuttonViewComponent
      },
      {
        path: "metabutton/:mode/:metaobjectid/:metaobjectname/:parentobjectid/:parentobjectname/:embeddedobject",
        component: MetabuttonNewComponent
      },
      {
        path: "metabutton/:mode/:id/:name/:metaobjectid/:metaobjectname/:parentobjectid/:parentobjectname/:embeddedobject",
        component: MetabuttonNewComponent
      },

      { path: "metalayout", component: MetaLayoutNewComponent },

      {
        path: "customview/:mode/:id/:metalayoutname/:displayname/:metaobjectid/:metaobjectname/:profileid/:publicaccess",
        component: CustomViewNewComponent
      },
      // {path: 'customview/:mode/:id/:name/:displayname/:metaobjectid/:metaobjectname/:profileid/:publicaccess',component: CustomViewListComponent},

      {
        path: "customview/:mode/:metaobjectid/:metaobjectname/:profileid",
        component: CustomViewNewComponent
      },

      {
        path: "refinedlayout/:mode/:metaobjectid/:metaobjectname/:profileid",
        component: RefinedlayoutnewComponent
      },

      {
        path: "refinedlayout/:mode/:id/:metalayoutname/:displayname/:metaobjectid/:metaobjectname/:profileid/:publicaccess",
        component: RefinedlayoutnewComponent
      },

      {
        path: "validationrule/:mode/:metaobjectid/:metaobjectname/:profileid",
        component: ValidationrulenewComponent
      },

      {
        path: "validationrule/:mode/:id/:name/:metaobjectid/:metaobjectname",
        component: ValidationrulenewComponent
      },

      {
        path: "customview/:mode/:id/:metalayoutname/:metaobjectid/:metaobjectname",
        component: FieldLayoutComponent
      },
      //  {path: 'customview/:mode/:id/:name/:displayname/:metaobjectid/:metaobjectname', component: MetaLayoutQuickComponent},

      {
        path: "metalayout/:mode/:metaobjectid/:metaobjectname/:profileid",
        component: FieldLayoutComponent
      },
      {
        path: "crudmessage/:mode",
        component: CrudmessagenewComponent
      },
      {
        path: "crudmessage/:mode/:id",
        component: CrudmessagenewComponent
      },
      {
        path: "crudmessagelist",
        component: CrudmessagelistComponent
      },
      {
        path: "errormessagelist",
        component: ErrormessagelistComponent
      },
      {
        path: "errormessage/:mode",
        component: ErrormessagenewComponent
      },
      {
        path: "errormessage/:mode/:id",
        component: ErrormessagenewComponent
      },
      {
        path: "sectionrootlist",
        component: SectionrootlistComponent
      },
      {
        path: "sectionroot/:mode",
        component: SectionrootnewComponent
      },
      {
        path: "sectionroot/:mode/:id/:type",
        component: SectionrootnewComponent
      },

      {
        path: "modulesettinglist",
        component: ModulesettinglistComponent
      },
      {
        path: "modulesetting/:mode",
        component: ModulesettingnewComponent
      },
      {
        path: "modulesetting/:mode/:id",
        component: ModulesettingnewComponent
      },

      { path: "domainsettinglist", component: DomainSettingslistComponent },

      { path: "domainsettinglist/:mode", component: DomainConfinewComponent },

      {
        path: "domainsettinglist/:mode/:id",
        component: DomainConfinewComponent
      },

      {
        path: "domainsectionlist/:domainkey/:id",
        component: domainsectionectionnewComponent
      },
      {
        path: "domainsection/:mode/:domainkey/:domainid",
        component: DomainConfigSectionComponent
      },
      {
        path: "domainsection/:mode/:domainkey/:domainid/:id",
        component: DomainConfigSectionComponent
      },
      // {path: "domainsection/:mode/:domainkey/:id",component:DomainfieldslistComponent},

      {
        path: "domainfieldslist/:section/:id",
        component: DomainfieldslistComponent
      },
      //  {path: "domainsettingfields/:mode",component:DomainsettingsconfigkeyComponent},
      {
        path: "domainsettingfields/:mode/:section/:sectinid",
        component: DomainsettingsconfigkeyComponent
      },
      {
        path: "domainsettingfields/:mode/:section/:sectinid/:id",
        component: DomainsettingsconfigkeyComponent
      },
      { path: "errorcodelist", component: ErrorcodelistComponent },
      { path: "errorcode/:mode", component: ErrorcodenewComponent },
      { path: "errorcode/:mode/:id", component: ErrorcodenewComponent }

      //  {path: 'metalayout/:mode/:metaobjectid/:metaobjectname/:profileid', component: FieldLayoutComponent},

      //  {path: 'metalayout/:mode/:metalayoutid/:metaobjectid/:metaobjectname/:displayname', component: FieldLayoutComponent},
    ]
  }
];

@NgModule({
  imports: [
    RouterModule.forRoot(routes, {
      anchorScrolling: "enabled",
      onSameUrlNavigation: "reload",
      scrollPositionRestoration: "enabled"
    })
  ],
  exports: [RouterModule]
})
export class AppRoutingModule {}
